const fieldsToDisplay = [
  {
    fieldName: 'User name',
    fieldTitle: 'User name',
    fieldPropParent: 'fieldsFixed'
  },
  {
    fieldName: 'E-mail',
    fieldTitle: 'E-mail',
    fieldPropParent: 'fieldsFixed'
  },
  {
    fieldName: 'Type',
    fieldTitle: 'Type',
    fieldPropParent: 'fields'
  },
  {
    fieldName: 'price',
    fieldTitle: 'Price'
  }
]
const dateDisplaySettings = {
  locales: 'en-US',
  options: { year: 'numeric', month: 'long', day: 'numeric' }
}
export default { fieldsToDisplay, dateDisplaySettings }
